export const POSTS_HEIGHT = 206;

export const METRICS_HEIGHT = 615;

export const GEO_HEIGHT = 128;

export const STATS_HEIGHT = 572;

export const UTM_HEIGHT = 175;
